import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
@Component({
  selector: 'gotx-grid-simple',
  templateUrl: './gotx-grid-simple.component.html',
  styleUrls: ['./gotx-grid-simple.component.css']
})
export class GotxGridSimpleComponent implements OnInit {

  @Input('columns') columns: any[];
  @Input('datasource') datasource: any[];

  @Output() selectedRow = new EventEmitter<String>();
  constructor() { }

  ngOnInit() {
  }
  
  rowClick(params){
    this.selectedRow.emit(params);

  }
}
